"use strict";
"use client";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");
Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.default = void 0;
var _createSvgIcon = _interopRequireDefault(require("./utils/createSvgIcon"));
var _jsxRuntime = require("react/jsx-runtime");
const SvgIcon = (0, _createSvgIcon.default)( /*#__PURE__*/(0, _jsxRuntime.jsx)("path", {
  d: "M120-160v-640l760 320zm80-120 474-200-474-200v140l240 60-240 60zm0 0v-400z"
}), 'SendOutlined', {
  viewBox: "0 -960 960 960"
});
var _default = exports.default = SvgIcon;